import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../assets/css/common.css';
import styles from '../assets/css/route-check.module.css';
import CustomButtons from '../components/CustomButtons';
import { routeService } from '../services/routeService';

function EditRouteRegistration() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};


  const [routes, setRoutes] = useState(
  state.routes && state.routes.length > 0
  ? state.routes
  : [{ routeName: '', fromStation: '', toStation: '', oneWayCost: '', commuterPassCost: '' }]
  );

  const [applicant, setApplicant] = useState(state.applicant || '');
  const [address, setAddress] = useState(state.address || '');
  const [busRequired, setBusRequired] = useState(state.busRequired || '');
  const [walkingImpossible, setWalkingImpossible] = useState(state.walkingImpossible || '');
  const [totalCost, setTotalCost] = useState(state.totalCost || '');
  const [attachment, setAttachment] = useState(state.attachmentURL || null);
  const [errorMessage, setErrorMessage] = useState('');
  const [clicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleRouteChange = (index, field, value) => {
    const newRoutes = [...routes];
    newRoutes[index][field] = value;
    setRoutes(newRoutes);
  };

  const addRow = () => {
    setRoutes([...routes, { routeName: '', fromStation: '', toStation: '', oneWayCost: '', commuterPassCost: '' }]);
  };

  const removeRow = (index) => {
    if (routes.length === 1) return;
    const newRoutes = routes.filter((_, i) => i !== index);
    setRoutes(newRoutes);
  };

  const handleFileChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onloadend = () => {
    setAttachment(reader.result);
  };
  reader.readAsDataURL(file);
};

const normalizeBooleanField = (value) => {
  if (value === 'はい') return 1;
  if (value === 'いいえ') return 0;
};

  const handleUpdate = async () => {
    if (clicked || loading) return;

    // バリデーションチェック
    if (

      !busRequired ||
      !walkingImpossible ||
      !totalCost ||
      !attachment ||
      routes.some(route =>
        !route.routeName.trim() ||
        !route.fromStation.trim() ||
        !route.toStation.trim() ||
        !route.oneWayCost ||
        !route.commuterPassCost
      )
    ) {
      setErrorMessage('すべての項目を入力してください（添付ファイルも含みます）');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    setClicked(true);
    setLoading(true);

        try {
            await routeService.update({
            applicant,
            address,
            busRequired: normalizeBooleanField(busRequired),
            walkingImpossible: normalizeBooleanField(walkingImpossible),
            totalCost,
            routes,
            attachment,
            });

            navigate('/update-complete-page', { replace: true });
        } catch (error) {
            alert(error.message || '更新に失敗しました。');
            console.error('更新エラー:', error);
        } finally {
            setClicked(false);
            setLoading(false);
        }
    };

  return (
    <div className={styles.container}>
      <div className="route-check-card">
        <h1 className={`${styles["text-primary"]} text-center mb-4`}>交通経路更新</h1>

        {/* エラーメッセージ表示 */}
        {errorMessage && (
          <div className="alert alert-danger" role="alert">
            {errorMessage}
          </div>
        )}

        <form onSubmit={(e) => e.preventDefault()}>
          {/* 基本情報 */}
          <h2 className={styles["section-title"]}>基本情報</h2>
          <table className={styles["details-table"]}>
            <tbody>
              <tr><th>申請者</th><td>{applicant}</td></tr>
              <tr><th>現住所</th><td>{address}</td></tr>
            </tbody>
          </table>

          {/* 交通経路情報 */}
          <h2 className={`${styles["section-title"]}`}>交通経路情報</h2>
          <table className="table">
            <thead>
              <tr>
                <th>交通機関名</th><th>発駅</th><th>着駅</th><th>片道料金</th><th>定期代</th><th>操作</th>
              </tr>
            </thead>
            <tbody>
              {routes.map((route, index) => (
                <tr key={index}>
                  <td><input type="text" className="form-control" placeholder="例: JR山手線" value={route.routeName} onChange={(e) => handleRouteChange(index, 'routeName', e.target.value)} required /></td>
                  <td><input type="text" className="form-control" placeholder="例: 新宿" value={route.fromStation} onChange={(e) => handleRouteChange(index, 'fromStation', e.target.value)} required /></td>
                  <td><input type="text" className="form-control" placeholder="例: 東京" value={route.toStation} onChange={(e) => handleRouteChange(index, 'toStation', e.target.value)} required /></td>
                  <td><input type="number" className="form-control" placeholder="例: 250" value={route.oneWayCost} onChange={(e) => handleRouteChange(index, 'oneWayCost', e.target.value)} required /></td>
                  <td><input type="number" className="form-control" placeholder="例: 10000" value={route.commuterPassCost} onChange={(e) => handleRouteChange(index, 'commuterPassCost', e.target.value)} required /></td>
                  <td>
                    {routes.length > 1 && (
                      <button type="button" className="btn btn-danger btn-sm" onClick={() => removeRow(index)}>削除</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button type="button" className="btn btn-secondary btn-sm mb-3" onClick={addRow}>行を追加</button>

          {/* 利用状況 */}
          <h2 className={`${styles["section-title"]}`}>利用状況</h2>
          <div className="mb-3">
            <label className="form-label">自宅から最寄駅までバスを利用しますか？</label>
            <div className={styles["radio-group"]}>
              <div className="form-check">
                <input type="radio" name="bus" value="はい" checked={busRequired === 'はい'} onChange={(e) => setBusRequired(e.target.value)} required/>
                <label>はい</label>
              </div>
              <div className="form-check">
                <input type="radio" name="bus" value="いいえ" checked={busRequired === 'いいえ'} onChange={(e) => setBusRequired(e.target.value)}/>
                <label>いいえ</label>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">徒歩が不可能な距離（直線距離2km以上）ですか？</label>
            <div className={styles["radio-group"]}>
              <div className="form-check">
                <input type="radio" name="walk" value="はい" checked={walkingImpossible === 'はい'} onChange={(e) => setWalkingImpossible(e.target.value)} required/>
                <label>はい</label>
              </div>
              <div className="form-check">
                <input type="radio" name="walk" value="いいえ" checked={walkingImpossible === 'いいえ'} onChange={(e) => setWalkingImpossible(e.target.value)}/>
                <label>いいえ</label>
              </div>
            </div>
          </div>

          {/* 交通費総額 */}
          <div className="mb-3">
            <label className="form-label">交通費総額</label>
            <input type="number" className="form-control" placeholder="例: 20000" value={totalCost} onChange={(e) => setTotalCost(e.target.value)} required />
          </div>

          {/* 添付ファイル */}
          <h2 className={`${styles["section-title"]}`}>現住所から最寄駅までの経路情報</h2>
          <div className="mb-3">
            <label className="form-label">添付ファイル（地図や経路）</label>
            <input type="file" onChange={handleFileChange} className="form-control" />
          </div>

          {/* 送信ボタン */}
          <div className="d-grid mt-4">
            <CustomButtons
            leftLabel="戻る"
            rightLabel="更新する"
            rightDisabled={clicked || loading}
            rightLoading={loading}
            rightLoadingLabel="更新中..."
            onLeftClick={() => window.history.back()}
            onRightClick={handleUpdate}
            />
          </div>
        </form>


      </div>
    </div>
  );
}

export default EditRouteRegistration;
